import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { borderRadius, colors, spacing, typographyFlat } from '../../styles/tokens';
import {
  INVENTORY_LOOKUP_GAMES,
  INVENTORY_SEALED_LOOKUP,
  INVENTORY_SHARED_SECTIONS,
  inventorySharedHref,
} from '../../lib/inventoryNav';

interface SectionNavItem {
  label: string;
  path: string;
  match: (pathname: string) => boolean;
}

function matchesSection(pathname: string, path: string): boolean {
  return pathname === path || pathname.startsWith(`${path}/`);
}

const ITEMS: SectionNavItem[] = [
  ...INVENTORY_LOOKUP_GAMES.map((game) => ({
    label: game.label,
    path: game.path,
    match: (pathname: string) => pathname === game.path,
  })),
  {
    label: INVENTORY_SEALED_LOOKUP.label,
    path: INVENTORY_SEALED_LOOKUP.path,
    match: (pathname: string) => matchesSection(pathname, INVENTORY_SEALED_LOOKUP.path),
  },
  ...INVENTORY_SHARED_SECTIONS.map((section) => ({
    label: section.label,
    path: section.path,
    match: (pathname: string) => matchesSection(pathname, section.path),
  })),
];

export const InventorySectionNav: React.FC = () => {
  const location = useLocation();

  return (
    <nav style={styles.nav} aria-label="Inventory sections">
      {ITEMS.map((item) => {
        const active = item.match(location.pathname);
        return (
          <Link
            key={item.path}
            to={inventorySharedHref(item.path, location.pathname)}
            style={{
              ...styles.link,
              ...(active ? styles.linkActive : {}),
            }}
            aria-current={active ? 'page' : undefined}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
};

const styles = {
  nav: {
    display: 'inline-flex',
    flexWrap: 'wrap' as const,
    gap: spacing.xs,
    borderRadius: borderRadius.full,
    backgroundColor: colors.gray100,
    padding: spacing.xs,
    marginTop: spacing.md,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    padding: `${spacing.xs} ${spacing.md}`,
    borderRadius: borderRadius.full,
    color: colors.textSecondary,
    backgroundColor: 'transparent',
    fontSize: typographyFlat.fontSize.sm,
    fontWeight: typographyFlat.fontWeight.semibold,
    lineHeight: '1.2',
    transition: 'all 0.2s ease',
  },
  linkActive: {
    color: colors.primaryDark,
    backgroundColor: colors.white,
    boxShadow: `inset 0 0 0 1px ${colors.border}`,
  },
};

export default InventorySectionNav;
